import * as React from 'react';
import { SVGProps } from 'react';

const Summary = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 18'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M16.0833 1.41667V4.25H1.91667V1.41667H16.0833ZM16.0833 0H1.91667C1.54094 0 1.18061 0.149255 0.914932 0.414932C0.649255 0.680609 0.5 1.04094 0.5 1.41667V4.25C0.5 4.62572 0.649255 4.98606 0.914932 5.25173C1.18061 5.51741 1.54094 5.66667 1.91667 5.66667H16.0833C16.4591 5.66667 16.8194 5.51741 17.0851 5.25173C17.3507 4.98606 17.5 4.62572 17.5 4.25V1.41667C17.5 1.04094 17.3507 0.680609 17.0851 0.414932C16.8194 0.149255 16.4591 0 16.0833 0Z'
      fill='#000'
    />
    <path
      d='M4.75 8.49967V15.583H1.91667V8.49967H4.75ZM4.75 7.08301H1.91667C1.54094 7.08301 1.18061 7.23226 0.914932 7.49794C0.649255 7.76362 0.5 8.12395 0.5 8.49967V15.583C0.5 15.9587 0.649255 16.3191 0.914932 16.5847C1.18061 16.8504 1.54094 16.9997 1.91667 16.9997H4.75C5.12572 16.9997 5.48606 16.8504 5.75173 16.5847C6.01741 16.3191 6.16667 15.9587 6.16667 15.583V8.49967C6.16667 8.12395 6.01741 7.76362 5.75173 7.49794C5.48606 7.23226 5.12572 7.08301 4.75 7.08301Z'
      fill='#000'
    />
    <path
      d='M16.0833 8.49967V15.583H8.99992V8.49967H16.0833ZM16.0833 7.08301H8.99992C8.6242 7.08301 8.26386 7.23226 7.99818 7.49794C7.73251 7.76362 7.58325 8.12395 7.58325 8.49967V15.583C7.58325 15.9587 7.73251 16.3191 7.99818 16.5847C8.26386 16.8504 8.6242 16.9997 8.99992 16.9997H16.0833C16.459 16.9997 16.8193 16.8504 17.085 16.5847C17.3507 16.3191 17.4999 15.9587 17.4999 15.583V8.49967C17.4999 8.12395 17.3507 7.76362 17.085 7.49794C16.8193 7.23226 16.459 7.08301 16.0833 7.08301Z'
      fill='#000'
    />
  </svg>
);

export default Summary;
